webpackJsonp([34],{

/***/ "Q8Cs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MainLanding = (function () {
    function MainLanding() {
        this.topVideoSlides = [
            {
                videoUrl: 'https://videos.animatron.com/landing/main/2product_wave_low.mp4',
                title: 'any.landing.top.title2',
                subtitle: 'any.landing.top.subtitle2',
                description: 'any.landing.top.description2',
                btnName: 'any.landing.top.button2',
                btnUrl: '/wave/landing'
            },
            {
                videoUrl: 'https://videos.animatron.com/landing/main/slider_studio.mp4',
                title: 'any.landing.top.title1',
                subtitle: 'any.landing.top.subtitle1',
                description: 'any.landing.top.description1',
                btnName: 'any.landing.top.button1',
                btnUrl: '/studio/landing'
            }
        ];
    }
    return MainLanding;
}());
exports.MainLanding = MainLanding;
angular.module('animatronApp.mainLanding', []).component('mainLanding', {
    controller: MainLanding,
    templateUrl: __webpack_require__("rVl+")
});


/***/ }),

/***/ "rVl+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/main-landing_9d3d20c6f563a21f46b69e3bca8edb0f.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/34-7812b7d297ba59488b87.min.js